export enum MODAL_TYPE {
  ADD = 'add',
  EDIT = 'edit',
  EMPTY = ''
}
